module.exports = __webpack_public_path__ + "static/media/oberflex-bamboufinambre-1200x2490.bf6f96f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-bamboufinambre-1200x2490.jpg
// module id = 984
// module chunks = 37